import { GET_USER_FROM_SESSION } from 'actions/Types';

/**
 * Get a user from the session
 *
 */
export const getUserFromSession = () => {
  return dispatch => {
    const action = {
      type: GET_USER_FROM_SESSION,
      request: async apiClient => {
        return apiClient.token.getUser();
      }
    };

    dispatch(action);
  };
};
